import { AvatarModal } from 'components/Modals/Player/Avatar';
import { ContactModal } from 'components/Modals/Player/Contact';
import { DetailsModal } from 'components/Modals/Player/Details';
import { CreateSportModal } from 'components/Modals/Player/Sport/Create';
import { UpdateSportModal } from 'components/Modals/Player/Sport/Update';
import { CreateTeamModal } from 'components/Modals/Player/Team/Create';
import { UpdateTeamModal } from 'components/Modals/Player/Team/Update';
import { TeamVisitsModal } from 'components/Modals/Player/Team/Visits';
import { VitalModal } from 'components/Modals/Player/Vital';
import { type ComponentProps } from 'react';

export type PlayerModalType =
  | 'player.avatar'
  | 'player.contact'
  | 'player.details'
  | 'player.sport.create'
  | 'player.sport.update'
  | 'player.team.create'
  | 'player.team.update'
  | 'player.team.visits'
  | 'player.vital';

export interface PlayerModalPropsMap {
  'player.avatar': ComponentProps<typeof AvatarModal>;
  'player.contact': ComponentProps<typeof ContactModal>;
  'player.details': ComponentProps<typeof DetailsModal>;
  'player.sport.create': ComponentProps<typeof CreateSportModal>;
  'player.sport.update': ComponentProps<typeof UpdateSportModal>;
  'player.team.create': ComponentProps<typeof CreateTeamModal>;
  'player.team.update': ComponentProps<typeof UpdateTeamModal>;
  'player.team.visits': ComponentProps<typeof TeamVisitsModal>;
  'player.vital': ComponentProps<typeof VitalModal>;
}

export const playerModals = {
  'player.avatar': AvatarModal,
  'player.contact': ContactModal,
  'player.details': DetailsModal,
  'player.sport.create': CreateSportModal,
  'player.sport.update': UpdateSportModal,
  'player.team.create': CreateTeamModal,
  'player.team.update': UpdateTeamModal,
  'player.team.visits': TeamVisitsModal,
  'player.vital': VitalModal,
};
